import Title from '@/components/Title/Title';
import Button from '@/components/homepage/Button/Button';
import { ITitle } from '@/components/BuilderIO/common/CommonFields';
import { getComponentMargin, getAnchorId } from '@/utils/builderUtils';
import beTwMerge from '@/utils/beTwMerge';

interface LinkSectionProps {
  /**
   * Optional large header.
   * - content*: The content of the header
   * - titleHTMLTag: Heading level that will be used to render the optional header. Defaults to 'h2'
   * - titleSize: Select one of the styles 'extraLarge' | 'large' | 'medium' | 'small'.
   * - titleWeight: Optional header weight. Defaults to 'normal'
   */
  title?: ITitle;
  /**
   * Turn on to add margin to the bottom of the component
   */
  margin?: boolean;
  /**
   * Give to the component an anchor link id
   */
  anchorLinkID?: string;
  /**
   * The list of links.
   * - label*: Text of the link
   * - url*: Url to link to
   */
  links: LinkSectionItemProps[];
}

interface LinkSectionItemProps {
  label: string;
  url: string;
}

export default function LinkSection({ title, margin = false, anchorLinkID, links }: LinkSectionProps) {
  return (
    <section
      {...getAnchorId(anchorLinkID)}
      className={beTwMerge(
        'tw-items-center tw-content-center tw-flex tw-font-[Avenir] tw-flex-col tw-px-2 tw-w-full md:tw-px-4',
        getComponentMargin(margin)
      )}
    >
      {title?.content && (
        <Title component={title.titleHTMLTag} size={title.titleSize} weight={title.titleWeight} className="tw-m-[32px]">
          {title.content}
        </Title>
      )}
      <div
        className={beTwMerge(
          'tw-flex tw-flex-col tw-gap-[16px] md:tw-flex-row md:tw-max-w-[1056px] md:tw-gap-x-4 md:tw-gap-y-6  tw-justify-center tw-flex-wrap tw-w-full',
          ``
        )}
      >
        {links
          ?.slice(0, 8)
          .map((link: LinkSectionItemProps, index: number) => (
            <LinkSectionItem2 key={index} label={link.label} url={link.url} />
          ))}
      </div>
    </section>
  );
}

export function LinkSectionItem({ label, url, ...rest }) {
  return (
    <a
      className="tw-no-underline hover:tw-no-underline hover:tw-text-color-white hover:tw-bg-color-black "
      href={url}
      {...rest}
      aria-label={`${label} on ${url?.replace(/\/$/, '').split('/').pop()?.replace(/-/g, ' ')}`}
    >
      {label}
    </a>
  );
}
export function LinkSectionItem2({ label, url, ...rest }) {
  return (
    <Button
      type="primary"
      color="black"
      className="hover:tw-text-color-white hover:tw-bg-color-black tw-text-base !tw-leading-[22px] tw-font-[500] tw-outline-color-[#183e40] tw-outline tw-outline-1 tw-py-4 tw-px-8 tw-text-center tw-h-[4.75rem] !tw-flex tw-items-center tw-justify-center tw-basis-[23%] lg:tw-basis-[23.7%] xl:tw-basis-[252px]"
      href={url}
      {...rest}
      label={label}
      ariaLabel={`${label} on ${url?.replace(/\/$/, '').split('/').pop()?.replace(/-/g, ' ')}`}
    />
  );
}
